export default "__VITE_ASSET__3619fdb8__"